import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../UserContext";
import { useNavigate } from "react-router-dom";

import CenteredPageContainer from "../components/layout_components/CenteredPageContainer";
import PlaceholderCardLayout from "../components/layout_components/PlaceholderCardLayout";
import Button from "../components/common_components/Button";
import CenteredLoadingIcon from "../components/common_components/CenteredLoadingIcon"
import ReferralsTable from "../components/referrals_components/ReferralsTable";

// API Calls
import ReferralAPI from "../api/api_calls/ReferralAPI";



function ReferralsPage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();
    const navigate = useNavigate();


    const [referrals, setReferrals] = useState([]);
    const [referralLink, setReferralLink] = useState("");
    const [tierInfo, setTierInfo] = useState(null);
    const [showReferralSignUpCard, setShowReferralSignUpCard] = useState(false);
    const [loadComplete, setLoadComplete] = useState(false);

    // --------------------------------------------
    // First, we fetch the user's wallets
    // --------------------------------------------

    useEffect(() => {
        document.title = 'Referrals | Despark';


        async function removeReferralsHighlight() {
            await ReferralAPI.removeReferralsHighlight();
            refreshUser();
        }


        async function getUserReferrals() {
            const data = await ReferralAPI.index();

            if (data.success) {
                setReferrals(data.referrals);
                setReferralLink(data.referral_link);
                setTierInfo(data.tier_info);
                setLoadComplete(true);
                if (user.emphasize_referrals) {
                    removeReferralsHighlight();
                }
            } else {
                alert.show("Unable to load referrals. Try again later", { type: 'error' })
            }
        }

        getUserReferrals();
    }, []);

    const generateReferralLink = async () => {
        const data = await ReferralAPI.generateReferralLink();
        if (data.success) {
            setReferralLink(data.referral_link);
            setShowReferralSignUpCard(false);

        } else {
            alert.show("Unable to generate referral link. Try again later", { type: 'error' })
        }
    }

    function copyLink() {
        navigator.clipboard.writeText(referralLink);
        alert.success("Copied to clipboard!");
    }


    // --------------------------------------------
    // --------------------------------------------
    // ----------------Render Logic---------------
    // --------------------------------------------
    // --------------------------------------------

    // Logic for this page:
    // If there are NO wallets, show the AddWalletCard
    // If there are wallets, show the WalletsTable
    // On load, disconnect any wallets
    // Once the user connects a wallet, they are shown the AddWalletsCard
    // They are prompted to sign their wallet
    // Once they sign their wallet, or disconnect their wallet, they go back to default 
    // (either table or Add depending on number of wallets)
    return (
        <CenteredPageContainer>
            {!loadComplete ? (
                <CenteredLoadingIcon />
            ) :
                <>
                    {showReferralSignUpCard ? (
                        <ReferralSignUpCard
                            generateReferralLink={generateReferralLink}
                            cancelReferralLink={() => setShowReferralSignUpCard(false)}
                        />
                    ) : (
                        <ReferralsTable
                            referrals={referrals}
                            getLink={() => setShowReferralSignUpCard(true)}
                            referralLink={referralLink}
                            tierInfo={tierInfo}
                            copyLink={copyLink}
                        />
                    )
                    }
                </>
            }
        </CenteredPageContainer>
    )
}



function ReferralSignUpCard(props) {

    return (
        <PlaceholderCardLayout>
            <div className="placeholder-card-text-content-container">
                <h1 className="referral-card-title centered-h1-card-text">Refer friends. Earn $$.</h1>
                <div className="left-aligned-text body-medium grey-400-text">
                    You AND your friend will each earn $5.
                    <br />
                    <ul className="referral-card-list">
                        <li className="referral-card-list-item">Users must sign up using your link</li>
                        <li className="referral-card-list-item">Users must complete an interview session</li>
                        <li className="referral-card-list-item"> Users cannot be from Nigeria or India (countries subject to change)</li>
                    </ul>
                </div>
            </div>
            <div className="full-width-button-container">
                <Button size="large" fullWidth={true} onClick={props.generateReferralLink} >Get link</Button>
            </div>
        </PlaceholderCardLayout>
    )
}


export default ReferralsPage